const WIDGET_PRIORITY = 0.5;
var Constants = {
  WIDGET_PRIORITY
};

export { WIDGET_PRIORITY, Constants as default };
